import { render } from "./RestaurantAdd.vue?vue&type=template&id=7c849e1b&scoped=true"
import script from "./RestaurantAdd.vue?vue&type=script&lang=js"
export * from "./RestaurantAdd.vue?vue&type=script&lang=js"

import "./RestaurantAdd.vue?vue&type=style&index=0&id=7c849e1b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c849e1b"]])

export default __exports__